angular.module('lwNamb').controller('manageTrainingButtonCtrl', ['$scope', '$routeParams',
  function($scope, $routeParams) {
    $scope.buttonType = $routeParams.buttonType;
  }
]);
